import { lazyWithPreload } from 'react-lazy-with-preload';

const UserDetailPage = lazyWithPreload(() => import('./pages/user-detail/Page'));
const UserListPage = lazyWithPreload(() => import('./pages/user-list/Page'));
const GuestUserDetailPage = lazyWithPreload(() => import('./pages/guest-user-detail/Page'));

const Routes = [
    {
        path: 'users',
        element: <UserListPage />,
    },
    {
        path: 'users/:userId',
        element: <UserDetailPage />,
    },
    {
        path: 'guest-users/:guestUserId',
        element: <GuestUserDetailPage />,
    },
];

export default Routes;
